import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FilterTickIcon } from './svgIcon'; // Assuming you have a Tick icon component

function FilterMapper(props) {
  const {
    content,
    filter,
    selectedFilter,
    setFilter,
    keyValue,
  } = props;
  const [selectedItems, setSelectedItems] = useState([]); // To track selected items
  const handleItemClick = (item) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected?.includes(item)) {
        return prevSelected?.filter((i) => i !== item);
      }
      return [...prevSelected, item];
    });
    const object = { filterBy: selectedFilter, result: item, key: keyValue };
    const filterExists = filter.some(
      (filters) => filters.filterBy === selectedFilter && filters.result === item,
    );
    if (filterExists) {
      setFilter(filter.filter(
        (filters) => !(filters.filterBy === selectedFilter && filters?.result === item),
      ));
    } else {
      setFilter([...filter, object]);
    }
  };

  useEffect(() => {
    const updatedSelectedItems = filter
      .filter((item) => item?.filterBy === selectedFilter)
      .map((item) => item?.result); // Update selectedItems based on filter changes
    setSelectedItems(updatedSelectedItems);
  }, [filter, selectedFilter]);
  return (
    <div className="Filter-mapper-wrap">
      {content?.map((data) => (
        <div
          key={data} // Added a key for better performance and to avoid warnings
          className={`filter-item ${selectedItems?.includes(data) ? 'selected' : ''}`}
          onClick={() => handleItemClick(data)} // Toggle selection
          role="presentation" // Used presentation role for clickable items
        >
          {selectedItems?.includes(data) && <FilterTickIcon />} {/* Show tick icon when selected */}
          <span
            className={selectedItems?.includes(data) ? 'selected-text' : ''}
          >
            {data}
          </span>
        </div>
      ))}
    </div>
  );
}

FilterMapper.propTypes = {
  content: PropTypes.arrayOf(PropTypes.string).isRequired, // Updated prop type to accept array of strings
  setFilter: PropTypes.func.isRequired,
  filter: PropTypes.arrayOf.isRequired,
  selectedFilter: PropTypes.string.isRequired,
  keyValue: PropTypes.string.isRequired,
};

export default FilterMapper;
